import { render, staticRenderFns } from "./addReportModal.vue?vue&type=template&id=908830a8&scoped=true&"
import script from "./addReportModal.vue?vue&type=script&lang=js&"
export * from "./addReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908830a8",
  null
  
)

export default component.exports